// export const API_URL = "https://admin-api.awnservices.com/admin";
export const API_URL = "https://shaimaadminapi.appgrowthcompany.com/admin";
// export const SOCKET_URL = "https://admin-api.awnservices.com/";
export const SOCKET_URL = "https://shaimaadminapi.appgrowthcompany.com/admin";

export const END_POINTS = {
  login: "onboarding/login",
  upload: "/media",
  get_user: "onboarding",
  logout: "onboarding/logout",
  forgotPassword: "onboarding/send-otp",
  verifyOtp: "onboarding/verify-otp/",
  resetPassword: "onboaring/reset-password/",
  changePassword: "onboarding/change-password",
  uploadMedia: "media/upload/",
  dashboardData: "onboarding/dashboard",
  changeGraphStatus: "onboarding/changeGraphStatus",
  cmsSetting: "cmsSetting",
  receivedNotification: "notification/receivedNotification",

  category: "category",
  notification: "notification",
  customer: "customer",
  propertydetail: "propertydetail",
  issue: "issue",
  invoice: "customer/invoice",
  faq: "faq",
  cms: "cms",
  offer: "offer",
  accessRole: "subadminaccess",
  rating: "rating",
  customerSupport: "customersupport",
  payment: "offer/payment-list",
  exportEarningGraph: '/onboarding/exportEarningGraph'
};
